import React from 'react';
import * as PiIcons from 'react-icons/pi';
import { capitalizeSection } from './userEditModel';

/**
 * The glyph a permission/feature section is drawn with.
 *
 * The map lived duplicated in three admin files; a section that gained an icon
 * in one of them stayed a gear in the others.
 */
const SECTION_ICON_MAP: Record<string, string> = {
  'Dashboard': 'PiDashboard',
  'Tasks': 'PiCheckSquare',
  'Calendar': 'PiCalendar',
  'Messages': 'PiChat',
  'Clients': 'PiUsers',
  'Lawyers': 'PiUserCircle',
  'Projects': 'PiTreeStructure',
  'Matters': 'PiBriefcase',
  'Files': 'PiFiles',
  'Research': 'PiMagnifyingGlass',
  'Tables': 'PiGridFour',
  'Analytics': 'PiChartBar',
  'Data Sources': 'PiDatabase',
  'Finder': 'PiUserSwitch',
  'Templates': 'PiFileText',
  'People': 'PiUsers',
  'Departments': 'PiBuilding',
  'Teams': 'PiUsersThree',
  'Finance': 'PiCoinVertical',
};

export const sectionIcon = (name: string, className = 'h-4 w-4'): JSX.Element => {
  const iconKey = SECTION_ICON_MAP[capitalizeSection(name)] || SECTION_ICON_MAP[name] || 'PiGear';
  const IconComponent =
    (PiIcons as any)[`${iconKey}Light`] || (PiIcons as any)[iconKey] || PiIcons.PiGearLight;
  return <IconComponent className={className} />;
};

export default sectionIcon;
